import clsx from "clsx";
import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

import type { TextAreaProps as UIKitTextAreaProps } from "@proda-ai/ui-kit";
import { TextArea as UIKitTextArea } from "@proda-ai/ui-kit";

const alignInputBorderStyles = {
    "& textarea": {
        border: "1px solid var(--proda-white-150) !important",
    },
};

const alignDisabledInputStyles = (
    disabled?: UIKitTextAreaProps["disabled"],
) => ({
    "& textarea:read-only": {
        backgroundColor: disabled === true ? "var(--proda-white-130)" : "white",
        cursor: disabled === true ? "not-allowed" : "pointer",
    },
});

const allowInputsWithoutLabel = (label?: UIKitTextAreaProps["label"]) =>
    label === undefined
        ? {
              "& label, & .uikit-field-label, & .uikit-text-area__label": {
                  display: "none",
              },
          }
        : ({} as Record<string, never>);

export type TextAreaProps = JSX.IntrinsicAttributes &
    Omit<UIKitTextAreaProps, "label" | "children"> & {
        label?: UIKitTextAreaProps["label"];
        sx?: BoxProps["sx"];
    };

const testId = "TextArea";
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (props, ref) => {
        const { sx, label, disabled, className, ...otherProps } = props;

        return (
            <Box
                component={UIKitTextArea}
                ref={ref}
                data-testid={testId}
                className={clsx([testId, className])}
                label={label ?? ""}
                disabled={disabled}
                sx={{
                    ...alignInputBorderStyles,
                    ...allowInputsWithoutLabel(label),
                    ...alignDisabledInputStyles(disabled),
                    ...sx,
                }}
                {...otherProps}
            />
        );
    },
);

TextArea.displayName = "TextArea";

export default TextArea;
